<template>
  <div class="jobs-manage-page">
    <div v-if="!isAdd && !isEdit">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addClickHandle">发布职位</el-button>
      <el-card class="box-card" v-for="item of myPublishedJobs" :key="item.id" shadow="hover">
        <div class="job-info">
          <div class="card-left">
            <div class="job-name">{{item['positionName']}}</div>
            <div class="job-base-info">
              <span class="job-salary">{{getDictName(item['salaryDict'])}}</span>
              <span>经验{{getDictName(item['experienceDict'])}} / {{getDictName(item['academicDegreeDict'])}}</span>
            </div>
          </div>
          <div class="card-right" @click="showMapHandle(item)">
            <el-link>{{item.positionCity}} {{item.positionAddress}}</el-link>
          </div>
        </div>
        <div class="bottom clearfix">
          <div class="card-left">
            <el-tag size="'mini'" v-for="tag of item['listLabel']" :key="tag.id">{{tag['labelName']}}</el-tag>
<!--            <el-tag :size="'mini'">关键词1</el-tag><el-tag :size="'mini'">关键词2</el-tag><el-tag :size="'mini'">关键词3</el-tag>-->
          </div>
          <div class="card-right">
            公司福利等（14薪，出国团建）
          </div>
        </div>
        <div class="job-manage-operate">
          <span style="margin-right: 10px;">已收到简历<span class="received-resumes" title="收到的简历" @click="showResumes(item.id)">{{item['pisitionCount']}}</span>份</span>
          <span class="el-icon-edit" title="编辑" @click="edit(item)"></span>
          <span class="el-icon-delete" title="删除" @click="deletePosition(item)"></span>
        </div>
      </el-card>
      <div style="float: right;margin-top: 10px" v-if="myPublishedJobs.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[20, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>
      <div class="no-data" v-if="myPublishedJobs.length === 0 && $store.get('user')">暂无数据</div>
      <div class="no-login-tip" v-if="!$store.get('user')">请使用招聘者账号<span style="color: #409eff;cursor: pointer;" @click="goLogin()">登录</span>后查看和发布职位信息</div>
    </div>

    <div v-else class="job-edit">
      <el-form ref="jobParam" :model="jobParam" label-width="100px" :rules="jobParamCheckRules">
        <el-form-item label="职位名称" prop="name">
          <el-input v-model="jobParam.name"></el-input>
        </el-form-item>
        <el-form-item label="工作城市" prop="city">
<!--          <el-input v-model="jobParam.city"></el-input>-->
          <el-cascader
            v-model="cityBind"
            :options="cityOptions"
            :clearable="true"
            :props="{ expandTrigger: 'hover' }"
            @change="selectCity">
          </el-cascader>
        </el-form-item>
        <el-form-item label="工作地点" prop="place">
          <el-input v-model="jobParam.place" @focus="showSelectPlacePointHandle()"></el-input>
<!--          <div @click="showSelectPlacePointHandle()">在地图中选择</div>-->
        </el-form-item>
        <div class="job-requirement">职位要求</div>
        <el-form-item label="学历">
          <el-select v-model="jobParam.education" placeholder="请选择">
            <el-option
              v-for="item in educationOption"
              :key="item['dictNum']"
              :label="item['dictName']"
              :value="item['dictNum']">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作经验">
          <el-select v-model="jobParam.workExperience" placeholder="请选择">
            <el-option
              v-for="item in workExperienceOption"
              :key="item['dictNum']"
              :label="item['dictName']"
              :value="item['dictNum']">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="薪资范围">
          <el-select v-model="jobParam.salaryRange" placeholder="请选择" @change="keyWordInit">
            <el-option
              v-for="item in salaryRangeOption"
              :key="item['dictNum']"
              :label="item['dictName']"
              :value="item['dictNum']">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别要求">
          <el-radio-group v-model="jobParam.gender">
            <el-radio :label="'00'">不限</el-radio>
            <el-radio :label="'01'">男</el-radio>
            <el-radio :label="'02'">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="任职要求" prop="jobRequirement">
          <el-input type="textarea" v-model="jobParam.jobRequirement" :autosize="{minRows: 2}"></el-input>
        </el-form-item>
        <el-form-item label="职位描述" prop="description">
          <el-input type="textarea" v-model="jobParam.description" :autosize="{minRows: 2}"></el-input>
        </el-form-item>
        <el-form-item label="职位关键词" prop="keyWords">
          <el-tag
            :key="tag"
            v-for="tag in jobParam.keyWords"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加关键词</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()">保存</el-button>
          <el-button @click="cancel()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="showCurPositionResumeFlag">
      <el-dialog :visible.sync="showCurPositionResumeFlag" :width="'600px'">
        <el-table
          ref="multipleTable"
          width="100%"
          border
          maxHeight="800"
          :data="curPositionReceivedResumesTableData"
          tooltip-effect="dark">
          <el-table-column
            fixed="left"
            prop="userName"
            :show-overflow-tooltip="true"
            label="姓名"
            width="130">
            <template slot-scope="scope">
              <span class="user-name" @click="showResume(scope.row)">{{scope.row.userName ? scope.row.userName : '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="jobStatus"
            label="求职状态"
            width="130"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            label="工作年限"
            width="100"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.workingLife ? scope.row.workingLife / 10 + '年' : '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            width="130"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="introduce"
            label="简介"
            width="300"
            :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <user-resume v-if="showUserResumeFlag" :showUserResumeFlag="showUserResumeFlag" :userResume="showUserResumeObj" @hideUserResume="hideUserResume()"></user-resume>
    <show-map v-if="showMap" :show-map-flag="showMap" :position-obj="positionObjForShowMap" @hideMap="showMap = false"></show-map>
    <select-map-point v-if="selectPlaceFlag" :show-map-flag="selectPlaceFlag" :default-keyword="defaultKeyword" @hideSelectMap="getLocationOfAddress"></select-map-point>
  </div>
</template>

<script>
/* eslint-disable quotes */
import ShowMap from '../ShowMap/ShowMap'
import SelectMapPoint from './SelectMapPoint'
import utilService from '../../utils/utilService'
import UserResume from './UserResume'
export default {
  name: 'JobsManage',
  components: {ShowMap, SelectMapPoint, UserResume},
  data () {
    let validateSyn = (rule, value, callback) => {
      this.utilService.checkSensitive({sensitive: value.trim()}, callback)
    }
    // let validateReq = (rule, value, callback) => {
    //   this.utilService.checkSensitive({sensitive: value.trim()}, '职位要求', callback)
    // }
    // let validateDes = (rule, value, callback) => {
    //   this.utilService.checkSensitive({sensitive: value.trim()}, '职位描述', callback)
    // }
    let validateKeywords = (rule, value, callback) => {
      this.utilService.checkSensitive({sensitive: JSON.stringify(value)}, callback)
    }
    return {
      utilService: utilService,
      cityBind: [],
      curPositionReceivedResumesTableData: [],
      isAdd: false,
      isEdit: false,
      showMap: false,
      selectPlaceFlag: false,
      showCurPositionResumeFlag: false,
      showUserResumeObj: null,
      showUserResumeFlag: false,
      defaultKeyword: '',
      addressTitle: '',
      positionObjForShowMap: null,
      myPublishedJobs: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      jobParam: {
        name: '',
        city: '',
        place: '',
        location: '',
        education: '',
        workExperience: '',
        salaryRange: '',
        gender: '00',
        jobRequirement: '',
        description: '',
        keyWords: []
      },
      // 各个字段的校验规则
      jobParamCheckRules: {
        name: [{ required: true, message: '请输入职位名称', trigger: 'blur' }, {validator: validateSyn, trigger: 'blur'}],
        city: [{ required: true, message: '请输入工作城市', trigger: 'blur' }],
        place: [{ required: true, message: '请输入工作地点', trigger: 'blur' }],
        jobRequirement: [{validator: validateSyn, trigger: 'blur'}],
        description: [{validator: validateSyn, trigger: 'blur'}],
        keyWords: [{validator: validateKeywords, trigger: 'blur'}]
      },
      inputVisible: false,
      inputValue: '',
      educationOption: [],
      workExperienceOption: [],
      salaryRangeOption: [],
      cityOptions: [
        {
          "label": "北京",
          "value": "北京",
          "children": [
            {
              "label": "东城区",
              "value": "东城区"
            },
            {
              "label": "西城区",
              "value": "西城区"
            },
            {
              "label": "崇文区",
              "value": "崇文区"
            },
            {
              "label": "宣武区",
              "value": "宣武区"
            },
            {
              "label": "朝阳区",
              "value": "朝阳区"
            },
            {
              "label": "海淀区",
              "value": "海淀区"
            },
            {
              "label": "丰台区",
              "value": "丰台区"
            },
            {
              "label": "石景山区",
              "value": "石景山区"
            },
            {
              "label": "房山区",
              "value": "房山区"
            },
            {
              "label": "通州区",
              "value": "通州区"
            },
            {
              "label": "顺义区",
              "value": "顺义区"
            },
            {
              "label": "昌平区",
              "value": "昌平区"
            },
            {
              "label": "大兴区",
              "value": "大兴区"
            },
            {
              "label": "怀柔区",
              "value": "怀柔区"
            },
            {
              "label": "平谷区",
              "value": "平谷区"
            },
            {
              "label": "门头沟区",
              "value": "门头沟区"
            },
            {
              "label": "密云县",
              "value": "密云县"
            },
            {
              "label": "延庆县",
              "value": "延庆县"
            }
          ]
        },
        {
          "label": "天津",
          "value": "天津",
          "children": [
            {
              "label": "和平区",
              "value": "和平区"
            },
            {
              "label": "河东区",
              "value": "河东区"
            },
            {
              "label": "河西区",
              "value": "河西区"
            },
            {
              "label": "南开区",
              "value": "南开区"
            },
            {
              "label": "河北区",
              "value": "河北区"
            },
            {
              "label": "红桥区",
              "value": "红桥区"
            },
            {
              "label": "东丽区",
              "value": "东丽区"
            },
            {
              "label": "西青区",
              "value": "西青区"
            },
            {
              "label": "北辰区",
              "value": "北辰区"
            },
            {
              "label": "津南区",
              "value": "津南区"
            },
            {
              "label": "武清区",
              "value": "武清区"
            },
            {
              "label": "宝坻区",
              "value": "宝坻区"
            },
            {
              "label": "滨海新区",
              "value": "滨海新区"
            },
            {
              "label": "静海县",
              "value": "静海县"
            },
            {
              "label": "宁河县",
              "value": "宁河县"
            },
            {
              "label": "蓟县",
              "value": "蓟县"
            }
          ]
        },
        {
          "label": "上海",
          "value": "上海",
          "children": [
            {
              "label": "黄浦区",
              "value": "黄浦区"
            },
            {
              "label": "卢湾区",
              "value": "卢湾区"
            },
            {
              "label": "徐汇区",
              "value": "徐汇区"
            },
            {
              "label": "长宁区",
              "value": "长宁区"
            },
            {
              "label": "静安区",
              "value": "静安区"
            },
            {
              "label": "普陀区",
              "value": "普陀区"
            },
            {
              "label": "闸北区",
              "value": "闸北区"
            },
            {
              "label": "虹口区",
              "value": "虹口区"
            },
            {
              "label": "杨浦区",
              "value": "杨浦区"
            },
            {
              "label": "闵行区",
              "value": "闵行区"
            },
            {
              "label": "宝山区",
              "value": "宝山区"
            },
            {
              "label": "嘉定区",
              "value": "嘉定区"
            },
            {
              "label": "浦东新区",
              "value": "浦东新区"
            },
            {
              "label": "金山区",
              "value": "金山区"
            },
            {
              "label": "松江区",
              "value": "松江区"
            },
            {
              "label": "青浦区",
              "value": "青浦区"
            },
            {
              "label": "奉贤区",
              "value": "奉贤区"
            },
            {
              "label": "崇明县",
              "value": "崇明县"
            }
          ]
        },
        {
          "label": "重庆",
          "value": "重庆",
          "children": [
            {
              "label": "渝中区",
              "value": "渝中区"
            },
            {
              "label": "大渡口区",
              "value": "大渡口区"
            },
            {
              "label": "江北区",
              "value": "江北区"
            },
            {
              "label": "南岸区",
              "value": "南岸区"
            },
            {
              "label": "北碚区",
              "value": "北碚区"
            },
            {
              "label": "渝北区",
              "value": "渝北区"
            },
            {
              "label": "巴南区",
              "value": "巴南区"
            },
            {
              "label": "长寿区",
              "value": "长寿区"
            },
            {
              "label": "双桥区",
              "value": "双桥区"
            },
            {
              "label": "沙坪坝区",
              "value": "沙坪坝区"
            },
            {
              "label": "万盛区",
              "value": "万盛区"
            },
            {
              "label": "万州区",
              "value": "万州区"
            },
            {
              "label": "涪陵区",
              "value": "涪陵区"
            },
            {
              "label": "黔江区",
              "value": "黔江区"
            },
            {
              "label": "永川区",
              "value": "永川区"
            },
            {
              "label": "合川区",
              "value": "合川区"
            },
            {
              "label": "江津区",
              "value": "江津区"
            },
            {
              "label": "九龙坡区",
              "value": "九龙坡区"
            },
            {
              "label": "南川区",
              "value": "南川区"
            },
            {
              "label": "綦江县",
              "value": "綦江县"
            },
            {
              "label": "潼南县",
              "value": "潼南县"
            },
            {
              "label": "荣昌县",
              "value": "荣昌县"
            },
            {
              "label": "璧山县",
              "value": "璧山县"
            },
            {
              "label": "大足县",
              "value": "大足县"
            },
            {
              "label": "铜梁县",
              "value": "铜梁县"
            },
            {
              "label": "梁平县",
              "value": "梁平县"
            },
            {
              "label": "开县",
              "value": "开县"
            },
            {
              "label": "忠县",
              "value": "忠县"
            },
            {
              "label": "城口县",
              "value": "城口县"
            },
            {
              "label": "垫江县",
              "value": "垫江县"
            },
            {
              "label": "武隆县",
              "value": "武隆县"
            },
            {
              "label": "丰都县",
              "value": "丰都县"
            },
            {
              "label": "奉节县",
              "value": "奉节县"
            },
            {
              "label": "云阳县",
              "value": "云阳县"
            },
            {
              "label": "巫溪县",
              "value": "巫溪县"
            },
            {
              "label": "巫山县",
              "value": "巫山县"
            },
            {
              "label": "石柱土家族自治县",
              "value": "石柱土家族自治县"
            },
            {
              "label": "秀山土家族苗族自治县",
              "value": "秀山土家族苗族自治县"
            },
            {
              "label": "酉阳土家族苗族自治县",
              "value": "酉阳土家族苗族自治县"
            },
            {
              "label": "彭水苗族土家族自治县",
              "value": "彭水苗族土家族自治县"
            }
          ]
        },
        {
          "label": "河北",
          "value": "河北",
          "children": [
            {
              "label": "石家庄",
              "value": "石家庄"
            },
            {
              "label": "唐山",
              "value": "唐山"
            },
            {
              "label": "秦皇岛",
              "value": "秦皇岛"
            },
            {
              "label": "邯郸",
              "value": "邯郸"
            },
            {
              "label": "邢台",
              "value": "邢台"
            },
            {
              "label": "保定",
              "value": "保定"
            },
            {
              "label": "张家口",
              "value": "张家口"
            },
            {
              "label": "承德",
              "value": "承德"
            },
            {
              "label": "沧州",
              "value": "沧州"
            },
            {
              "label": "廊坊",
              "value": "廊坊"
            },
            {
              "label": "衡水",
              "value": "衡水"
            }
          ]
        },
        {
          "label": "山西",
          "value": "山西",
          "children": [
            {
              "label": "太原",
              "value": "太原"
            },
            {
              "label": "大同",
              "value": "大同"
            },
            {
              "label": "阳泉",
              "value": "阳泉"
            },
            {
              "label": "长治",
              "value": "长治"
            },
            {
              "label": "晋城",
              "value": "晋城"
            },
            {
              "label": "朔州",
              "value": "朔州"
            },
            {
              "label": "晋中",
              "value": "晋中"
            },
            {
              "label": "运城",
              "value": "运城"
            },
            {
              "label": "忻州",
              "value": "忻州"
            },
            {
              "label": "临汾",
              "value": "临汾"
            },
            {
              "label": "吕梁",
              "value": "吕梁"
            }
          ]
        },
        {
          "label": "辽宁",
          "value": "辽宁",
          "children": [
            {
              "label": "沈阳",
              "value": "沈阳"
            },
            {
              "label": "大连",
              "value": "大连"
            },
            {
              "label": "鞍山",
              "value": "鞍山"
            },
            {
              "label": "抚顺",
              "value": "抚顺"
            },
            {
              "label": "本溪",
              "value": "本溪"
            },
            {
              "label": "丹东",
              "value": "丹东"
            },
            {
              "label": "锦州",
              "value": "锦州"
            },
            {
              "label": "营口",
              "value": "营口"
            },
            {
              "label": "阜新",
              "value": "阜新"
            },
            {
              "label": "辽阳",
              "value": "辽阳"
            },
            {
              "label": "盘锦",
              "value": "盘锦"
            },
            {
              "label": "铁岭",
              "value": "铁岭"
            },
            {
              "label": "朝阳",
              "value": "朝阳"
            },
            {
              "label": "葫芦岛",
              "value": "葫芦岛"
            }
          ]
        },
        {
          "label": "吉林",
          "value": "吉林",
          "children": [
            {
              "label": "长春",
              "value": "长春"
            },
            {
              "label": "吉林",
              "value": "吉林"
            },
            {
              "label": "四平",
              "value": "四平"
            },
            {
              "label": "辽源",
              "value": "辽源"
            },
            {
              "label": "通化",
              "value": "通化"
            },
            {
              "label": "白山",
              "value": "白山"
            },
            {
              "label": "松原",
              "value": "松原"
            },
            {
              "label": "白城",
              "value": "白城"
            },
            {
              "label": "延边朝鲜族自治州",
              "value": "延边朝鲜族自治州"
            }
          ]
        },
        {
          "label": "黑龙江",
          "value": "黑龙江",
          "children": [
            {
              "label": "哈尔滨",
              "value": "哈尔滨"
            },
            {
              "label": "齐齐哈尔",
              "value": "齐齐哈尔"
            },
            {
              "label": "鹤岗",
              "value": "鹤岗"
            },
            {
              "label": "双鸭山",
              "value": "双鸭山"
            },
            {
              "label": "鸡西",
              "value": "鸡西"
            },
            {
              "label": "大庆",
              "value": "大庆"
            },
            {
              "label": "伊春",
              "value": "伊春"
            },
            {
              "label": "牡丹江",
              "value": "牡丹江"
            },
            {
              "label": "佳木斯",
              "value": "佳木斯"
            },
            {
              "label": "七台河",
              "value": "七台河"
            },
            {
              "label": "黑河",
              "value": "黑河"
            },
            {
              "label": "绥化",
              "value": "绥化"
            },
            {
              "label": "大兴安岭",
              "value": "大兴安岭"
            }
          ]
        },
        {
          "label": "江苏",
          "value": "江苏",
          "children": [
            {
              "label": "南京",
              "value": "南京"
            },
            {
              "label": "苏州",
              "value": "苏州"
            },
            {
              "label": "无锡",
              "value": "无锡"
            },
            {
              "label": "常州",
              "value": "常州"
            },
            {
              "label": "镇江",
              "value": "镇江"
            },
            {
              "label": "南通",
              "value": "南通"
            },
            {
              "label": "泰州",
              "value": "泰州"
            },
            {
              "label": "扬州",
              "value": "扬州"
            },
            {
              "label": "盐城",
              "value": "盐城"
            },
            {
              "label": "连云港",
              "value": "连云港"
            },
            {
              "label": "徐州",
              "value": "徐州"
            },
            {
              "label": "淮安",
              "value": "淮安"
            },
            {
              "label": "宿迁",
              "value": "宿迁"
            }
          ]
        },
        {
          "label": "浙江",
          "value": "浙江",
          "children": [
            {
              "label": "杭州",
              "value": "杭州"
            },
            {
              "label": "宁波",
              "value": "宁波"
            },
            {
              "label": "温州",
              "value": "温州"
            },
            {
              "label": "嘉兴",
              "value": "嘉兴"
            },
            {
              "label": "湖州",
              "value": "湖州"
            },
            {
              "label": "绍兴",
              "value": "绍兴"
            },
            {
              "label": "金华",
              "value": "金华"
            },
            {
              "label": "衢州",
              "value": "衢州"
            },
            {
              "label": "舟山",
              "value": "舟山"
            },
            {
              "label": "台州",
              "value": "台州"
            },
            {
              "label": "丽水",
              "value": "丽水"
            }
          ]
        },
        {
          "label": "安徽",
          "value": "安徽",
          "children": [
            {
              "label": "合肥",
              "value": "合肥"
            },
            {
              "label": "芜湖",
              "value": "芜湖"
            },
            {
              "label": "蚌埠",
              "value": "蚌埠"
            },
            {
              "label": "淮南",
              "value": "淮南"
            },
            {
              "label": "马鞍山",
              "value": "马鞍山"
            },
            {
              "label": "淮北",
              "value": "淮北"
            },
            {
              "label": "铜陵",
              "value": "铜陵"
            },
            {
              "label": "安庆",
              "value": "安庆"
            },
            {
              "label": "黄山",
              "value": "黄山"
            },
            {
              "label": "滁州",
              "value": "滁州"
            },
            {
              "label": "阜阳",
              "value": "阜阳"
            },
            {
              "label": "宿州",
              "value": "宿州"
            },
            {
              "label": "巢湖",
              "value": "巢湖"
            },
            {
              "label": "六安",
              "value": "六安"
            },
            {
              "label": "亳州",
              "value": "亳州"
            },
            {
              "label": "池州",
              "value": "池州"
            },
            {
              "label": "宣城",
              "value": "宣城"
            }
          ]
        },
        {
          "label": "福建",
          "value": "福建",
          "children": [
            {
              "label": "福州",
              "value": "福州"
            },
            {
              "label": "厦门",
              "value": "厦门"
            },
            {
              "label": "莆田",
              "value": "莆田"
            },
            {
              "label": "三明",
              "value": "三明"
            },
            {
              "label": "泉州",
              "value": "泉州"
            },
            {
              "label": "漳州",
              "value": "漳州"
            },
            {
              "label": "南平",
              "value": "南平"
            },
            {
              "label": "龙岩",
              "value": "龙岩"
            },
            {
              "label": "宁德",
              "value": "宁德"
            }
          ]
        },
        {
          "label": "江西",
          "value": "江西",
          "children": [
            {
              "label": "南昌",
              "value": "南昌"
            },
            {
              "label": "景德镇",
              "value": "景德镇"
            },
            {
              "label": "萍乡",
              "value": "萍乡"
            },
            {
              "label": "九江",
              "value": "九江"
            },
            {
              "label": "新余",
              "value": "新余"
            },
            {
              "label": "鹰潭",
              "value": "鹰潭"
            },
            {
              "label": "赣州",
              "value": "赣州"
            },
            {
              "label": "吉安",
              "value": "吉安"
            },
            {
              "label": "宜春",
              "value": "宜春"
            },
            {
              "label": "抚州",
              "value": "抚州"
            },
            {
              "label": "上饶",
              "value": "上饶"
            }
          ]
        },
        {
          "label": "山东",
          "value": "山东",
          "children": [
            {
              "label": "济南",
              "value": "济南"
            },
            {
              "label": "青岛",
              "value": "青岛"
            },
            {
              "label": "淄博",
              "value": "淄博"
            },
            {
              "label": "枣庄",
              "value": "枣庄"
            },
            {
              "label": "东营",
              "value": "东营"
            },
            {
              "label": "烟台",
              "value": "烟台"
            },
            {
              "label": "潍坊",
              "value": "潍坊"
            },
            {
              "label": "济宁",
              "value": "济宁"
            },
            {
              "label": "泰安",
              "value": "泰安"
            },
            {
              "label": "威海",
              "value": "威海"
            },
            {
              "label": "日照",
              "value": "日照"
            },
            {
              "label": "莱芜",
              "value": "莱芜"
            },
            {
              "label": "临沂",
              "value": "临沂"
            },
            {
              "label": "德州",
              "value": "德州"
            },
            {
              "label": "聊城",
              "value": "聊城"
            },
            {
              "label": "滨州",
              "value": "滨州"
            },
            {
              "label": "菏泽",
              "value": "菏泽"
            }
          ]
        },
        {
          "label": "河南",
          "value": "河南",
          "children": [
            {
              "label": "郑州",
              "value": "郑州"
            },
            {
              "label": "开封",
              "value": "开封"
            },
            {
              "label": "洛阳",
              "value": "洛阳"
            },
            {
              "label": "平顶山",
              "value": "平顶山"
            },
            {
              "label": "安阳",
              "value": "安阳"
            },
            {
              "label": "鹤壁",
              "value": "鹤壁"
            },
            {
              "label": "新乡",
              "value": "新乡"
            },
            {
              "label": "焦作",
              "value": "焦作"
            },
            {
              "label": "濮阳",
              "value": "濮阳"
            },
            {
              "label": "许昌",
              "value": "许昌"
            },
            {
              "label": "漯河",
              "value": "漯河"
            },
            {
              "label": "三门峡",
              "value": "三门峡"
            },
            {
              "label": "南阳",
              "value": "南阳"
            },
            {
              "label": "商丘",
              "value": "商丘"
            },
            {
              "label": "信阳",
              "value": "信阳"
            },
            {
              "label": "周口",
              "value": "周口"
            },
            {
              "label": "驻马店",
              "value": "驻马店"
            }
          ]
        },
        {
          "label": "湖北",
          "value": "湖北",
          "children": [
            {
              "label": "武汉",
              "value": "武汉"
            },
            {
              "label": "黄石",
              "value": "黄石"
            },
            {
              "label": "十堰",
              "value": "十堰"
            },
            {
              "label": "荆州",
              "value": "荆州"
            },
            {
              "label": "宜昌",
              "value": "宜昌"
            },
            {
              "label": "襄樊",
              "value": "襄樊"
            },
            {
              "label": "鄂州",
              "value": "鄂州"
            },
            {
              "label": "荆门",
              "value": "荆门"
            },
            {
              "label": "孝感",
              "value": "孝感"
            },
            {
              "label": "黄冈",
              "value": "黄冈"
            },
            {
              "label": "咸宁",
              "value": "咸宁"
            },
            {
              "label": "随州",
              "value": "随州"
            },
            {
              "label": "恩施",
              "value": "恩施"
            }
          ]
        },
        {
          "label": "湖南",
          "value": "湖南",
          "children": [
            {
              "label": "长沙",
              "value": "长沙"
            },
            {
              "label": "株洲",
              "value": "株洲"
            },
            {
              "label": "湘潭",
              "value": "湘潭"
            },
            {
              "label": "衡阳",
              "value": "衡阳"
            },
            {
              "label": "邵阳",
              "value": "邵阳"
            },
            {
              "label": "岳阳",
              "value": "岳阳"
            },
            {
              "label": "常德",
              "value": "常德"
            },
            {
              "label": "张家界",
              "value": "张家界"
            },
            {
              "label": "益阳",
              "value": "益阳"
            },
            {
              "label": "郴州",
              "value": "郴州"
            },
            {
              "label": "永州",
              "value": "永州"
            },
            {
              "label": "怀化",
              "value": "怀化"
            },
            {
              "label": "娄底",
              "value": "娄底"
            },
            {
              "label": "湘西",
              "value": "湘西"
            }
          ]
        },
        {
          "label": "广东",
          "value": "广东",
          "children": [
            {
              "label": "广州",
              "value": "广州"
            },
            {
              "label": "深圳",
              "value": "深圳"
            },
            {
              "label": "珠海",
              "value": "珠海"
            },
            {
              "label": "汕头",
              "value": "汕头"
            },
            {
              "label": "韶关",
              "value": "韶关"
            },
            {
              "label": "佛山",
              "value": "佛山"
            },
            {
              "label": "江门",
              "value": "江门"
            },
            {
              "label": "湛江",
              "value": "湛江"
            },
            {
              "label": "茂名",
              "value": "茂名"
            },
            {
              "label": "肇庆",
              "value": "肇庆"
            },
            {
              "label": "惠州",
              "value": "惠州"
            },
            {
              "label": "梅州",
              "value": "梅州"
            },
            {
              "label": "汕尾",
              "value": "汕尾"
            },
            {
              "label": "河源",
              "value": "河源"
            },
            {
              "label": "阳江",
              "value": "阳江"
            },
            {
              "label": "清远",
              "value": "清远"
            },
            {
              "label": "东莞",
              "value": "东莞"
            },
            {
              "label": "中山",
              "value": "中山"
            },
            {
              "label": "潮州",
              "value": "潮州"
            },
            {
              "label": "揭阳",
              "value": "揭阳"
            },
            {
              "label": "云浮",
              "value": "云浮"
            }
          ]
        },
        {
          "label": "海南",
          "value": "海南",
          "children": [
            {
              "label": "海口",
              "value": "海口"
            },
            {
              "label": "三亚",
              "value": "三亚"
            }
          ]
        },
        {
          "label": "四川",
          "value": "四川",
          "children": [
            {
              "label": "成都",
              "value": "成都"
            },
            {
              "label": "自贡",
              "value": "自贡"
            },
            {
              "label": "攀枝花",
              "value": "攀枝花"
            },
            {
              "label": "泸州",
              "value": "泸州"
            },
            {
              "label": "德阳",
              "value": "德阳"
            },
            {
              "label": "绵阳",
              "value": "绵阳"
            },
            {
              "label": "广元",
              "value": "广元"
            },
            {
              "label": "遂宁",
              "value": "遂宁"
            },
            {
              "label": "内江",
              "value": "内江"
            },
            {
              "label": "乐山",
              "value": "乐山"
            },
            {
              "label": "南充",
              "value": "南充"
            },
            {
              "label": "眉山",
              "value": "眉山"
            },
            {
              "label": "宜宾",
              "value": "宜宾"
            },
            {
              "label": "广安",
              "value": "广安"
            },
            {
              "label": "达州",
              "value": "达州"
            },
            {
              "label": "雅安",
              "value": "雅安"
            },
            {
              "label": "巴中",
              "value": "巴中"
            },
            {
              "label": "资阳",
              "value": "资阳"
            },
            {
              "label": "阿坝",
              "value": "阿坝"
            },
            {
              "label": "甘孜",
              "value": "甘孜"
            },
            {
              "label": "凉山",
              "value": "凉山"
            }
          ]
        },
        {
          "label": "贵州",
          "value": "贵州",
          "children": [
            {
              "label": "贵阳",
              "value": "贵阳"
            },
            {
              "label": "六盘水",
              "value": "六盘水"
            },
            {
              "label": "遵义",
              "value": "遵义"
            },
            {
              "label": "安顺",
              "value": "安顺"
            },
            {
              "label": "铜仁",
              "value": "铜仁"
            },
            {
              "label": "毕节",
              "value": "毕节"
            },
            {
              "label": "黔西南",
              "value": "黔西南"
            },
            {
              "label": "黔东南",
              "value": "黔东南"
            },
            {
              "label": "黔南",
              "value": "黔南"
            }
          ]
        },
        {
          "label": "云南",
          "value": "云南",
          "children": [
            {
              "label": "昆明",
              "value": "昆明"
            },
            {
              "label": "曲靖",
              "value": "曲靖"
            },
            {
              "label": "玉溪",
              "value": "玉溪"
            },
            {
              "label": "保山",
              "value": "保山"
            },
            {
              "label": "昭通",
              "value": "昭通"
            },
            {
              "label": "丽江",
              "value": "丽江"
            },
            {
              "label": "普洱",
              "value": "普洱"
            },
            {
              "label": "临沧",
              "value": "临沧"
            },
            {
              "label": "德宏",
              "value": "德宏"
            },
            {
              "label": "怒江",
              "value": "怒江"
            },
            {
              "label": "迪庆",
              "value": "迪庆"
            },
            {
              "label": "大理",
              "value": "大理"
            },
            {
              "label": "楚雄",
              "value": "楚雄"
            },
            {
              "label": "红河",
              "value": "红河"
            },
            {
              "label": "文山",
              "value": "文山"
            },
            {
              "label": "西双版纳",
              "value": "西双版纳"
            }
          ]
        },
        {
          "label": "陕西",
          "value": "陕西",
          "children": [
            {
              "label": "西安",
              "value": "西安"
            },
            {
              "label": "铜川",
              "value": "铜川"
            },
            {
              "label": "宝鸡",
              "value": "宝鸡"
            },
            {
              "label": "咸阳",
              "value": "咸阳"
            },
            {
              "label": "渭南",
              "value": "渭南"
            },
            {
              "label": "延安",
              "value": "延安"
            },
            {
              "label": "汉中",
              "value": "汉中"
            },
            {
              "label": "榆林",
              "value": "榆林"
            },
            {
              "label": "安康",
              "value": "安康"
            },
            {
              "label": "商洛",
              "value": "商洛"
            }
          ]
        },
        {
          "label": "甘肃",
          "value": "甘肃",
          "children": [
            {
              "label": "兰州",
              "value": "兰州"
            },
            {
              "label": "嘉峪关",
              "value": "嘉峪关"
            },
            {
              "label": "金昌",
              "value": "金昌"
            },
            {
              "label": "白银",
              "value": "白银"
            },
            {
              "label": "天水",
              "value": "天水"
            },
            {
              "label": "武威",
              "value": "武威"
            },
            {
              "label": "酒泉",
              "value": "酒泉"
            },
            {
              "label": "张掖",
              "value": "张掖"
            },
            {
              "label": "庆阳",
              "value": "庆阳"
            },
            {
              "label": "平凉",
              "value": "平凉"
            },
            {
              "label": "定西",
              "value": "定西"
            },
            {
              "label": "陇南",
              "value": "陇南"
            },
            {
              "label": "临夏",
              "value": "临夏"
            },
            {
              "label": "甘南",
              "value": "甘南"
            }
          ]
        },
        {
          "label": "青海",
          "value": "青海",
          "children": [
            {
              "label": "西宁",
              "value": "西宁"
            },
            {
              "label": "海东",
              "value": "海东"
            },
            {
              "label": "海北",
              "value": "海北"
            },
            {
              "label": "海南",
              "value": "海南"
            },
            {
              "label": "黄南",
              "value": "黄南"
            },
            {
              "label": "果洛",
              "value": "果洛"
            },
            {
              "label": "玉树",
              "value": "玉树"
            },
            {
              "label": "海西",
              "value": "海西"
            }
          ]
        },
        {
          "label": "内蒙古",
          "value": "内蒙古",
          "children": [
            {
              "label": "呼和浩特",
              "value": "呼和浩特"
            },
            {
              "label": "包头",
              "value": "包头"
            },
            {
              "label": "乌海",
              "value": "乌海"
            },
            {
              "label": "赤峰",
              "value": "赤峰"
            },
            {
              "label": "通辽",
              "value": "通辽"
            },
            {
              "label": "鄂尔多斯",
              "value": "鄂尔多斯"
            },
            {
              "label": "呼伦贝尔",
              "value": "呼伦贝尔"
            },
            {
              "label": "巴彦淖尔",
              "value": "巴彦淖尔"
            },
            {
              "label": "乌兰察布",
              "value": "乌兰察布"
            },
            {
              "label": "锡林郭勒盟",
              "value": "锡林郭勒盟"
            },
            {
              "label": "兴安盟",
              "value": "兴安盟"
            },
            {
              "label": "阿拉善盟",
              "value": "阿拉善盟"
            }
          ]
        },
        {
          "label": "广西",
          "value": "广西",
          "children": [
            {
              "label": "南宁",
              "value": "南宁"
            },
            {
              "label": "柳州",
              "value": "柳州"
            },
            {
              "label": "桂林",
              "value": "桂林"
            },
            {
              "label": "梧州",
              "value": "梧州"
            },
            {
              "label": "北海",
              "value": "北海"
            },
            {
              "label": "防城港",
              "value": "防城港"
            },
            {
              "label": "钦州",
              "value": "钦州"
            },
            {
              "label": "贵港",
              "value": "贵港"
            },
            {
              "label": "玉林",
              "value": "玉林"
            },
            {
              "label": "百色",
              "value": "百色"
            },
            {
              "label": "贺州",
              "value": "贺州"
            },
            {
              "label": "河池",
              "value": "河池"
            },
            {
              "label": "来宾",
              "value": "来宾"
            },
            {
              "label": "崇左",
              "value": "崇左"
            }
          ]
        },
        {
          "label": "西藏",
          "value": "西藏",
          "children": [
            {
              "label": "拉萨",
              "value": "拉萨"
            },
            {
              "label": "那曲",
              "value": "那曲"
            },
            {
              "label": "昌都",
              "value": "昌都"
            },
            {
              "label": "林芝",
              "value": "林芝"
            },
            {
              "label": "山南",
              "value": "山南"
            },
            {
              "label": "日喀则",
              "value": "日喀则"
            },
            {
              "label": "阿里",
              "value": "阿里"
            }
          ]
        },
        {
          "label": "宁夏",
          "value": "宁夏",
          "children": [
            {
              "label": "银川",
              "value": "银川"
            },
            {
              "label": "石嘴山",
              "value": "石嘴山"
            },
            {
              "label": "吴忠",
              "value": "吴忠"
            },
            {
              "label": "固原",
              "value": "固原"
            },
            {
              "label": "中卫",
              "value": "中卫"
            }
          ]
        },
        {
          "label": "新疆维吾尔自治区",
          "value": "新疆维吾尔自治区",
          "children": [
            {
              "label": "乌鲁木齐",
              "value": "乌鲁木齐"
            },
            {
              "label": "克拉玛依",
              "value": "克拉玛依"
            },
            {
              "label": "吐鲁番",
              "value": "吐鲁番"
            },
            {
              "label": "哈密",
              "value": "哈密"
            },
            {
              "label": "和田",
              "value": "和田"
            },
            {
              "label": "阿克苏",
              "value": "阿克苏"
            },
            {
              "label": "喀什",
              "value": "喀什"
            },
            {
              "label": "克孜勒苏",
              "value": "克孜勒苏"
            },
            {
              "label": "巴音郭楞",
              "value": "巴音郭楞"
            },
            {
              "label": "昌吉",
              "value": "昌吉"
            },
            {
              "label": "博尔塔拉",
              "value": "博尔塔拉"
            },
            {
              "label": "伊犁",
              "value": "伊犁"
            },
            {
              "label": "塔城",
              "value": "塔城"
            },
            {
              "label": "阿勒泰",
              "value": "阿勒泰"
            }
          ]
        },
        {
          "label": "香港",
          "value": "香港",
          "children": [
            {
              "label": "香港岛",
              "value": "香港岛"
            },
            {
              "label": "九龙东",
              "value": "九龙东"
            },
            {
              "label": "九龙西",
              "value": "九龙西"
            },
            {
              "label": "新界东",
              "value": "新界东"
            },
            {
              "label": "新界西",
              "value": "新界西"
            }
          ]
        },
        {
          "label": "澳门",
          "value": "澳门",
          "children": [
            {
              "label": "澳门半岛",
              "value": "澳门半岛"
            },
            {
              "label": "离岛",
              "value": "离岛"
            }
          ]
        },
        {
          "label": "台湾",
          "value": "台湾",
          "children": [
            {
              "label": "台北",
              "value": "台北"
            },
            {
              "label": "高雄",
              "value": "高雄"
            },
            {
              "label": "基隆",
              "value": "基隆"
            },
            {
              "label": "新竹",
              "value": "新竹"
            },
            {
              "label": "台中",
              "value": "台中"
            },
            {
              "label": "嘉义",
              "value": "嘉义"
            },
            {
              "label": "台南市",
              "value": "台南市"
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleCurrentChange (val) {
      console.log(val)
      this.page.pageNum = val
      this.getMyPublishedJobs()
    },
    handleSizeChange (val) {
      console.log(val)
      this.page.pageSize = val
      this.getMyPublishedJobs()
    },
    addClickHandle () {
      if (!this.$store.get('user')) {
        this.$message.warning('请先登录！')
        return false
      }
      if (this.$store.get('user') && !this.$store.get('user').realName) {
        this.$message.warning('招聘者必须完善个人信息中的真实姓名才可发布职位信息！')
        return false
      } else {
        this.isAdd = !this.isAdd
      }
    },
    selectCity (v) {
      this.jobParam.city = v.join('/')
    },
    getMyPublishedJobs () {
      if (!this.$store.get('user')) {
        return false
      }
      let pageNum = this.page.pageNum
      let pageSize = this.page.pageSize
      this.$http.get(`${this.$api.getByCompanyCode.url}?pageNum=${pageNum}&pageSize=${pageSize}`).then(_ => {
        if (_ && _.code === 200 && _.data) {
          this.myPublishedJobs = _.data.list || []
          this.page.pageSize = _.data.pageSize || this.page.pageSize
          this.page.pageNum = _.data.pageNum || this.page.pageNum
          this.page.total = _.data.total || this.page.total
        }
      })
    },
    getDictName (item) {
      if (item && item['dictName']) {
        return item['dictName']
      } else {
        return '--'
      }
    },
    handleClose (tag) {
      this.jobParam.keyWords.splice(this.jobParam.keyWords.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.jobParam.keyWords.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    onSubmit () {
      console.log(this.jobParam)
      this.$refs['jobParam'].validate((valid) => {
        if (valid) {
          // 校验OK后调接口保存
          let param = {
            positionName: this.jobParam.name,
            positionCity: this.jobParam.city,
            positionAddress: this.jobParam.place,
            location: this.jobParam.location,
            education: this.jobParam.education || 'EDUCATION0001',
            experience: this.jobParam.workExperience || 'EXPERIENCE0001',
            salary: this.jobParam.salaryRange || 'SALARY0001',
            sexReq: this.jobParam.gender,
            skillRequirement: this.jobParam.jobRequirement,
            description: this.jobParam.description,
            labels: this.jobParam.keyWords.join(',')
          }
          if (this.isAdd) {
            this.$http.post(this.$api.savePosition.url, param).then(_ => {
              if (_ && _.code === 200) {
                console.log(_)
                this.$message.success('职位信息录入成功')
                this.page.pageSize = 20
                this.page.pageNum = 1
                this.getMyPublishedJobs()
              }
            }).catch(e => {
              console.log(e)
              this.$message.error('职位信息录入失败')
            }).finally(f => {
              console.log(f)
            })
          }
          if (this.isEdit) {
            param.id = this.jobParam.id
            this.$http.put(this.$api.updatePosition.url, param).then(_ => {
              if (_ && _.code === 200) {
                console.log(_)
                this.$message.success('职位信息更新成功')
                this.page.pageSize = 20
                this.page.pageNum = 1
                this.getMyPublishedJobs()
              }
            }).catch(e => {
              console.log(e)
              this.$message.error('职位信息修改失败')
            }).finally(f => {
              console.log(f)
            })
          }
          this.jobParam = {
            name: '',
            city: '',
            place: '',
            education: '',
            workExperience: '',
            salaryRange: '',
            gender: '00',
            jobRequirement: '',
            description: '',
            keyWords: []
          }
          this.isAdd = false
          this.isEdit = false
          // this.$http.post(this.$api.checkSensitiveWords.url, param).then(_ => {
          //   if (_ && _.code === 200) {
          //   }
          //   if (_ && _.code !== 200 && _.msg) {
          //     this.$message.error(_.msg)
          //   }
          // })
        } else {
          // 校验出错，提示
          // console.log('error submit!!')
          return false
        }
      })
    },
    edit (job) {
      console.log(job)
      this.isEdit = true
      this.cityBind = job.positionCity.split('/')
      this.jobParam = {
        id: job.id,
        name: job.positionName,
        city: job.positionCity,
        place: job.positionAddress,
        location: job.location,
        education: job.education,
        workExperience: job.experience,
        salaryRange: job.salary,
        gender: job.sexReq,
        jobRequirement: job.skillRequirement,
        description: job.description,
        keyWords: job['listLabel'].map(item => item['labelName'])
      }
    },
    cancel () {
      this.isAdd = false
      this.isEdit = false
      this.jobParam = {
        name: '',
        city: '',
        place: '',
        education: '',
        workExperience: '',
        salaryRange: '',
        gender: '00',
        jobRequirement: '',
        description: '',
        keyWords: []
      }
    },
    deletePosition (positionItem) {
      this.$confirm('是否删除该条职位信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$http.delete(this.$api.deletePosition.url, {id: positionItem.id}).then(_ => {
          if (_ && _.code === 200) {
            this.$message.success('删除职位信息成功')
            this.page.pageSize = 20
            this.page.pageNum = 1
            this.getMyPublishedJobs()
          }
        })
      }).catch(() => {})
    },
    showMapHandle (item) {
      if (!item.location) {
        this.$alert('该职位暂无地图信息！', '提示', {type: 'warning'})
        return false
      }

      this.showMap = true
      this.positionObjForShowMap = item
      this.addressTitle = item.positionCity + ' ' + item.positionAddress
    },
    showSelectPlacePointHandle () {
      this.defaultKeyword = this.jobParam.place
      this.selectPlaceFlag = true
    },
    getLocationOfAddress (data) {
      this.selectPlaceFlag = false
      this.jobParam.place = data.content
      this.jobParam.location = data.location.join(',')
      console.log(data)
    },
    showResumes (positionId) {
      this.$http.get(this.$api.getApplyResume.url, {positionId}).then(_ => {
        if (_ && _.code === 200 && _.data) {
          this.curPositionReceivedResumesTableData = _.data || []
          this.showCurPositionResumeFlag = true
        }
      })
    },
    showResume (row) {
      this.showUserResumeObj = row
      this.showUserResumeFlag = true
    },
    hideUserResume () {
      this.showUserResumeObj = null
      this.showUserResumeFlag = false
    },
    goLogin () {
      this.$router.push({
        name: 'Login',
        params: null
      })
    },
    keyWordInit (e) {
      let keyword = ''
      this.salaryRangeOption.map(item => {
        if (item.dictNum === e) {
          keyword = item.dictName
        }
        this.jobParam.keyWords = this.jobParam.keyWords.filter(_item => _item !== item.dictName)
      })
      if (keyword && keyword !== '不限') {
        this.jobParam.keyWords.unshift(keyword)
      }
    }
  },
  created () {
    this.page.pageSize = 20
    this.page.pageNum = 1
    this.getMyPublishedJobs()
    // 学历下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'EDUCATION'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.educationOption = _.data
      }
    }).catch(e => {
      console.log(e)
    }).finally(f => {
      console.log(f)
    })

    // 工作经验下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'EXPERIENCE'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.workExperienceOption = _.data
      }
    }).catch(e => {
      console.log(e)
    }).finally(f => {
      console.log(f)
    })

    // 薪资下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'SALARY'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.salaryRangeOption = _.data
      }
    }).catch(e => {
      console.log(e)
    }).finally(f => {
      console.log(f)
    })
  },
  computed: {
  }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
  .jobs-manage-page {
    width: 1000px;
    text-align: left;
  }

  .job-requirement {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: bolder;
    color: #666666;
    /*text-align: left;*/
  }

  /deep/ .el-form-item__label, /deep/ .el-form-item__content {
    text-align: left;
  }

  /deep/ .el-card {
    margin-top: 10px;
  }

  /deep/ .el-card__body {
    padding: 10px;
    position: relative;
  }

  .job-info {
    /*width: calc(100% - 100px);*/
  }

  .job-manage-operate {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .el-icon-edit, .el-icon-delete {
    cursor: pointer;
    margin-right: 5px;
  }
  .el-icon-edit {
    color: #409eff;
  }
  .el-icon-delete {
    color: #f56c6c;
  }
  .el-icon-edit:active,.el-icon-delete:active {
    /*box-shadow: 1px 2px 15px rgba(0, 0, 0, .3);*/
    text-shadow: 2px 2px 2px grey;
  }

  .job-edit {
    width: 500px;
  }

  /deep/ .el-tag {
    margin-right: 10px;
  }
  /deep/ .input-new-tag {
    width: 100px;
  }

  .clearfix {
    border-top: 1px dashed #cccccc;
    margin-top: 10px;
    padding-top: 10px;
  }
  .card-left {
    display: inline-block;
    width: calc(65% - 10px);
  }

  .card-right {
    display: inline-block;
    width: 35%;
  }

  .job-name {
    color: #409eff;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .job-salary {
    display: inline-block;
    color: #fd5f39;
    font-size: 16px;
    width: 120px;
  }
  .no-data {
    text-align: center;
    line-height: 200px;
    font-size: 24px;
    color: #ccc;
  }
  .no-login-tip {
    text-align: center;
    font-size: 16px;
    color: #313131;
  }
  .received-resumes {
    margin: 0 5px;
    color: #409eff;
    cursor: pointer;
  }
  .user-name:hover {
    cursor: pointer;
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Recruit/JobsManage.vue